import { createFileRoute } from "@tanstack/react-router";
import { PortalReportDetailV2Page } from "@/components/v2/pages/portal-report-detail-v2-page";

export const Route = createFileRoute("/portal/reports/$reportId")({
  component: PortalReportDetailV2Page,
});
